// src/ProductData.js
import LINKS from "../../Constants/links";
import { getProductImages } from "../../Components/ProductImages";

export const products = [
  {
    id: "topical-luteolin-serum",
    name: "Lutology™ Topical Luteolin Serum",

    shortDescription:
      "Minimalist, science-inspired topical luteolin serum designed to support scalp comfort and resilient-looking hair.",

    priceDisplay: "$34 – $85",

    badges: [
      "Fragrance-free",
      "Dye-free",
      "Minimalist formula",
      "Vegan",
    ],

    ...getProductImages("topical-luteolin-serum"),

    inci: [
      "Propylene Glycol",
      "PEG-400",
      "Alcohol",
      "Aqua (Water)",
      "Luteolin",
      "Vegetable Glycerin",
      "Phenoxyethanol",
      "Ethylhexylglycerin",
    ],

    howToUse: [
      "Apply a few drops to clean, dry scalp.",
      "Gently massage for 10–20 seconds.",
      "If a yellow tint appears, allow absorption for 20 minutes before cleansing.",
      "For full effect, leave on for several hours.",
      "Recommended for nighttime use.",
    ],

    whatsNotIn: [
      "No Synthetic Fragrance",
      "No Dyes",
      "No Silicones",
      "No Parabens",
      "No Mineral Oil",
    ],

    safetyNotes: [
      "For external use only.",
      "Avoid contact with eyes.",
      "Patch test prior to first use.",
      "Not intended to diagnose, treat, cure, or prevent any disease.",
      "This product is cosmetic only.",
    ],

    scienceSection: {
      studyTitle: "2024 Peer-Reviewed Study (Iida et al.)",
      studyUrl: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC11673595/",
      summary:
        "A 2024 study showed that topical luteolin preserved melanocyte stem cells and reduced hair graying in mice, suggesting potential anti-graying benefits.",
      videoTitle: "Science of Luteolin (ModernHealthspan)",
      videoUrl:
        "https://www.youtube.com/watch?v=D0njhqZQ00A&ab_channel=ModernHealthspan",
    },

    keyFeatures: [
      "High-purity luteolin",
      "Optimized solvent system for smooth application",
      "Lightweight, fast-absorbing feel",
      "Fragrance-free and dye-free",
      "Available in tinted 30ml, 50ml, and 100ml bottles",
    ],


    etsyUrl: LINKS.ETSY_SERUM,
  },

  {
    id: "topical-luteolin-cream",
    name: "Lutology™ Topical Luteolin Cream",

    shortDescription:
      "A nourishing scalp cream formulated with Luteolin, Shea Butter, and Sweet Almond Oil to support hair vitality and scalp health.",

    badges: [
      "Luteolin Infused",
      "Shea Butter",
      "Scalp Care",
      "Nourishing Formula",
    ],

    ...getProductImages("topical-luteolin-cream"),

    inci: [
      "Aqua (Water)",
      "Cetyl Alcohol",
      "Glyceryl Stearate SE",
      "Butyrospermum Parkii (Shea) Butter",
      "Luteolin",
      "Isopropyl Myristate",
      "PEG-40",
      "Prunus Amygdalus Dulcis (Sweet Almond) Oil",
      "Cera Alba (Beeswax)",
      "Glycerin",
      "Iscaguard PEG (Preservative)",
      "Citric Acid",
      "Tocopherol (Vitamin E)",
    ],

    howToUse: [
      "Apply a small amount directly to the scalp or hair roots.",
      "Massage gently until absorbed.",
      "Leave on for at least 20 minutes or overnight for best results.",
      "Rinse or wash off as part of your regular hair care routine.",
      "Can be applied to dry or damp scalp.",
    ],

    whatsNotIn: [
      "No Synthetic Fragrance",
      "No Dyes",
      "No Silicones",
      "No Parabens",
      "No Mineral Oil",
    ],

    safetyNotes: [
      "For external use only.",
      "Avoid contact with eyes.",
      "Patch test prior to first use.",
      "Not intended to diagnose, treat, cure, or prevent any disease.",
      "This product is cosmetic only.",
    ],

    scienceSection: {
      studyTitle: "2024 Peer-Reviewed Study (Iida et al.)",
      studyUrl: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC11673595/",
      summary:
        "Topical luteolin has been studied for its potential to preserve melanocyte stem cells, supporting hair pigmentation and scalp health.",
      videoTitle: "Science of Luteolin (ModernHealthspan)",
      videoUrl:
        "https://www.youtube.com/watch?v=D0njhqZQ00A&ab_channel=ModernHealthspan",
    },

    keyFeatures: [
      "Creamy texture enriched with Shea Butter & Beeswax",
      "Delivers Luteolin directly to the scalp",
      "Moisturizing without being overly greasy",
      "Contains Vitamin E for antioxidant support",
      "Fragrance-free and dye-free formulation",
    ],


    etsyUrl: LINKS.ETSY_SHOP || "https://www.etsy.com/shop/Lutology",
  },

  {
    id: "topical-luteolin-lotion",
    name: "Lutology™ Topical Luteolin Lotion",

    shortDescription:
      "A lightweight, hydrating luteolin lotion that absorbs faster than a cream while offering more moisture than a serum.",

    badges: [
      "Lightweight Texture",
      "Hydrating Emulsion",
      "Scalp & Skin",
      "Fragrance-free",
      "Minimalist formula",
    ],

    ...getProductImages("topical-luteolin-lotion"),

    inci: [
      "Aqua (Water)",
      "Cetyl Alcohol",
      "Glycerol Monostearate SE",
      "Butyrospermum Parkii (Shea Butter)",
      "Isopropyl Myristate",
      "PEG-40",
      "Prunus Amygdalus Dulcis (Sweet Almond) Oil",
      "Cera Alba (Beeswax)",
      "Caprylic/Capric Triglyceride",
      "Glycerin",
      "Cetearyl Alcohol",
      "Phenoxyethanol (Iscaguard PEG)",
      "Citric Acid",
      "Tocopherol (Vitamin E)",
      "Tetrasodium EDTA",
      "Aloe Barbadensis Leaf Extract",
      "Sodium Benzoate",
      "PEG-400",
      "Propylene Glycol",
      "Luteolin",
    ],

    howToUse: [
      "Apply a thin layer to clean, dry skin or scalp.",
      "Massage gently until fully absorbed.",
      "If a yellow tint appears, allow absorption for at least 20 minutes before rinsing.",
      "Leaving it on is recommended for full effect.",
      "Recommended for daily use, morning or night.",
    ],

    whatsNotIn: [
      "No Added Fragrance",
      "No Added Colors",
      "No Silicones",
      "No Parabens",
      "No Mineral Oil",
    ],

    safetyNotes: [
      "For external use only.",
      "Avoid contact with eyes, irritated skin, or broken skin.",
      "Patch test prior to first use.",
      "Discontinue use if irritation occurs.",
      "Not intended to diagnose, treat, cure, or prevent any disease.",
      "This product is cosmetic only.",
    ],

    scienceSection: {
      studyTitle: "2024 Peer-Reviewed Study (Iida et al.)",
      studyUrl: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC11673595/",
      summary:
        "A 2024 study showed that topical luteolin preserved melanocyte stem cells and reduced hair graying in mice, supporting continued interest in topical luteolin for scalp and hair applications.",
      videoTitle: "Science of Luteolin (ModernHealthspan)",
      videoUrl:
        "https://www.youtube.com/watch?v=D0njhqZQ00A&ab_channel=ModernHealthspan",
    },

    keyFeatures: [
      "Lightweight lotion texture that absorbs faster than a cream",
      "Provides more moisture than a serum without feeling heavy or greasy",
      "Designed for scalp and skin use",
      "Good fit for larger areas or oily/combination skin types",
      "No added fragrance or unnecessary colors",
    ],


    etsyUrl: LINKS.ETSY_LOTION,
  },
];